
import './SubsidiariesStyles.css';

function SubsidiariesData (props) {
return (
    <>
        <div className="sub-card">
            <div className='sub-image'>
                <img alt='sub-img' src={ props.image }/>
            </div>
                <h4>{props.heading}</h4>
                <p>{props.text}</p>
        </div>
    </>
    )
} 
export default SubsidiariesData;